export default __webpack_public_path__ + "static/media/Terms.42fe3516.md";